<!-- Общая оболочка перехода статуса с кнопкой отправки вложенной формы -->
<template>
  <BaseModal :visible="visible" :title="title" size="md" @close="close">
    <slot v-if="visible" />
    <template #footer>
      <base-button :disabled="isSubmitting" @click="close">Назад</base-button>
      <base-primary-button :disabled="isSubmitting" type="submit" :form="formId">
        {{ title }}
      </base-primary-button>
    </template>
  </BaseModal>
</template>
<script>
export default {
  name: "RecordListStatusTransitionModal",
  props: {
    visible: { type: Boolean, default: false },
    title: { type: String, required: true },
    formId: { type: String, required: true },
    isSubmitting: { type: Boolean, default: false },
  },
  emits: ["close"],
  methods: {
    close() {
      if (!this.isSubmitting) this.$emit("close");
    },
  },
};
</script>
